// src/utils/dateUtils.js

/**
 * Formatea una fecha para mostrarla al usuario en formato español (dd/mm/aaaa).
 * Acepta un string ISO ("yyyy-mm-dd", opcionalmente con hora), un objeto Date,
 * o null/undefined. Devuelve "—" si el valor está vacío o no se puede interpretar.
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateEs(value) {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "—";
    const d = String(value.getDate()).padStart(2, "0");
    const m = String(value.getMonth() + 1).padStart(2, "0");
    const y = value.getFullYear();
    return `${d}/${m}/${y}`;
  }

  const s = String(value ?? "").trim();
  if (!s) return "—";

  const iso = s.slice(0, 10);
  const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, y, m, d] = match;
    return `${d}/${m}/${y}`;
  }

  return s;
}
